import {
	rehabReducer as RehabStore,
	initState as rehabInitState,
} from './Rehab.reducer';

import {
	choiceListReducer as ChoiceListStore,
	initState as choiceListInitState,
} from './ChoiceList.reducer';

import { utilReducer as util } from './util.reducer';

import {
	riskReducer as RiskStore,
	initState as riskInitState,
} from './Risk.reducer';

import { StoreState, utilStoreStateInitial } from '@Types';
import { combineReducers } from 'redux';
import { moduleNamespace } from '@Store/config.store';

export const initialState: StoreState = {
	RehabStore: rehabInitState,
	ChoiceListStore: choiceListInitState,
	util: utilStoreStateInitial(),
	RiskStore: riskInitState,
};

export default combineReducers({
	RehabStore,
	ChoiceListStore,
	util,
	RiskStore,
});

export const reducerKey = moduleNamespace;
